/**
 * Defines the supported stores for MButtonApp.
 */
export enum MButtonAppType {
  AppStore = 'App Store',
  GooglePlay = 'Google Play',
}

type BaseProps = Pick<
  React.AnchorHTMLAttributes<HTMLAnchorElement> & React.ButtonHTMLAttributes<HTMLButtonElement>,
  | 'className'
  | 'style'
  | 'onClick'
  | 'onFocus'
  | 'onBlur'
  | 'aria-label'
  | 'aria-labelledby'
  | 'tabIndex'
  | 'target'
  | 'rel'
>;

export interface MButtonAppProps extends BaseProps {
  /**
   * Type of button indicating which store icon/text to display.
   */
  type?: MButtonAppType;
  /**
   * Optional custom content (e.g. app store badge image). When provided, replaces the default store label.
   */
  children?: React.ReactNode;
  /**
   * When provided, renders as an anchor. When omitted, renders as a button.
   */
  href?: string;
}
